export default "__VITE_ASSET__DJSfOXaG__"